import React, { useEffect } from "react";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import {MAN_PL_CONST} from "../../../../../constants/ActionEnums/ManActionEnums";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import {InitiateProcessAction} from "../../../../../api/omnimap/omnimapActions";

const PlaatsInWerkplan = () => {
  useEffect(() => {
    $("#plaats_in_werkplan").on("show.bs.modal", function (event) {
      GC.GetEntityList(
        process.env.REACT_APP_CATALOG_WORK_PLANS,
        1,
        30,
        CallBackFunctions.WerkplanCallback,
        window.$mm_management_units_token
      );
    });
  });

  const handleSubmit = () => {
    $("#cover-spin").show(0);
    const element = $("input[name=werkplan]:checked");
    const workPlanId = element.attr("id");

    // var label = $(element).next("label").attr("for", werkplanId);
    // var model = { werkplan: werkplanId };
    // var selectedIds = [];
    // $("#example")
    //   .dataTable()
    //   .$("tr.selected")
    //   .each(function () {
    //     selectedIds.push($(this).attr("rowId"));
    //   });

    // GC.StartActivity(
    //   model,
    //   selectedIds,
    //   "1041f11d-46f4-4a46-a1c5-8e6d91f0877f",
    //   werkplanVerplaatst,
    //   window.$mm_management_units_token
    // );

    const model = {
      "action": MAN_PL_CONST.PLACE_IN_WORK_PLAN,
      "werkplan_identification": workPlanId,
      "identifications": GetSelected()
    }


    InitiateProcessAction(model, MAN_PL_CONST.END_POINT).then(()=>{

      $("#plaats_in_werkplan").modal("hide");
      window.$mm_schedule_tableReload();

    }).catch(()=>{
      alert('Something went wrong!')
      $("#cover-spin").hide(0);
    })
  };

  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="plaats_in_werkplan"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Plaats in werkplan</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input
              type="search"
              className="modal-search"
              placeholder="Zoeken naar werkplannen"
            />
            <div className="modal-scroll">
              <div id="werkplan-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_werkplan"
              className="btn-modal"
              onClick={handleSubmit}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaatsInWerkplan;
